import { convertMultipiers, UltraRouletteMultipier } from './Multipier';

export type GameResult = {
    ResultPoint: number;
    ResultMultipier: number;
    Multipier: number;
    Multipiers: Array<UltraRouletteMultipier>;
};
export const convertStringToResult = (resultString: string): GameResult => {
    const js = JSON.parse(resultString);
    return {
        ResultPoint: js.R,
        ResultMultipier: js.RM,
        Multipier: js.MS,
        Multipiers: convertMultipiers(js.M),
    } as GameResult;
};
